import { Select, SelectProps } from "antd"
import React, { useEffect, useState } from "react"
import useDebounce from "../../hooks/useDebounce"
import { GET_WAREHOUSES } from "../../pages/warehouses/queries"

import { useTranslation } from "react-i18next"
import { useQuery } from "@tanstack/react-query"

export interface ICustomSelectProps extends Partial<SelectProps<any>> {
  onChange?: (val: any) => void
  defaultValue?: any
  value?: any
  placeholder?: string
  hasEmpty?: boolean
  width?: string
  /** tog'a #3246: «Все» bandining nomi (masalan «Все склады») */
  allLabel?: string
}

export default function WarehouseSelect({
  onChange,
  defaultValue,
  value,
  hasEmpty = true,
  placeholder,
  width,
  allLabel,
  ...props
}: ICustomSelectProps) {
  const [query, setQuery] = useState("")
  const debouncedQuery = useDebounce(query, 500)
  const { t } = useTranslation()
  // tog'a #2232 (2026-09-21): komponent TO'LIQ boshqariladigan edi — ko'rsatiladigan qiymat faqat
  // `value`/`defaultValue`/asosiy ombordan olinardi. Shuning uchun `value` berilmagan joylarda (perevod,
  // sotuv, qaytarish formalari, zakaz oynasi) foydalanuvchi boshqa omborni tanlasa ham maydonda ASOSIY
  // ombor nomi qolib ketardi — «sklad tanlanmayapti». Endi tanlov ichki holatda saqlanadi:
  // `value` (boshqariladigan) > foydalanuvchi tanlovi > `defaultValue` (faqat BOSHLANG'ICH) > asosiy ombor.
  const [ichki, setIchki] = useState<any>(undefined)

  const {
    refetch: getWarehouses,
    isLoading: loading,
    data,
  } = useQuery(["defaultGET_WAREHOUSES", query], () =>
    GET_WAREHOUSES({ SearchText: query })
  )

  function fetchWarehouses(query: string) {
    getWarehouses()
  }

  useEffect(() => {
    fetchWarehouses(query)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuery])

  useEffect(() => {
    fetchWarehouses("")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // boshqariladigan maydon tozalansa (form.resetFields) ichki tanlov ham tushadi
  useEffect(() => {
    if (value === undefined) setIchki(undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    if (data?.data?.length && !hasEmpty) {
      // foydalanuvchi allaqachon tanlagan bo'lsa (ichki) — ro'yxat qayta yuklanganda uni bosib ketmaymiz
      if ((value === undefined || value === null) && defaultValue === undefined && ichki === undefined) {
        const selectedItem = data.data.find((w: any) => w.selected)
        const targetId = selectedItem ? selectedItem.id : data.data[0]?.id
        if (targetId && onChange) {
          onChange(targetId)
        }
      }
    }
    // tog'a #3055 (2026-09-29): faqat [data] ga bog'liq edi — forma qiymati keyin bo'sh qolsa (zakupka importi «Заполнить форму»),
    // maydonda asosiy sklad KO'RINARDI, lekin forma qiymati bo'sh edi → «Обязательное поле», import yuborilmasdi.
    // Endi `value` ham kuzatiladi: bo'sh bo'lsa asosiy sklad qayta yoziladi (qiymat o'rnatilgach shart bajarilmaydi — halqa yo'q).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.data, value])

  const selectedItem = data?.data?.find((w: any) => w.selected)
  const defaultVal = defaultValue !== undefined ? defaultValue : (!hasEmpty ? (selectedItem ? selectedItem.id : data?.data?.[0]?.id) : "")

  return (
    <Select
      className="headermargin_r"
      style={{ width: width }}
      allowClear
      {...props}
      size="large"
      value={(() => {
        const tanlangan =
          value !== undefined && value !== null ? value
            : ichki !== undefined ? ichki                       // #2232: foydalanuvchi tanlovi
            : defaultValue !== undefined && defaultValue !== null ? defaultValue
            : defaultVal
        return tanlangan !== "" && tanlangan !== undefined && tanlangan !== null ? String(tanlangan) : undefined
      })()}
      placeholder={placeholder}
      onSearch={(val) => setQuery(val)}
      showSearch
      loading={loading}
      filterOption={false}
      onChange={(val) => {
        setIchki(val === undefined || val === null ? "" : val)   // #2232: tozalansa bo'sh, aks holda tanlov
        if (onChange) {
          onChange(val)
        }
      }}
      options={[
        ...(hasEmpty ? [{ name: allLabel || t("all"), id: "0" }] : []),
        ...(data?.data || []),
      ].map((node) => ({
        label: `${node?.name || ""}${node?.selected ? " (Основной)" : ""}`,
        value: String(node?.id ?? ""),
      }))}
    />
  )
}
